import React, { useState } from "react";
import './Signup.css'
import signupimg from '../../assest/Log in & Contact Background Png.png'
import rocketimg from '../../assest/ExamSify Contact Png.png'
import googlelogoimg from '../../assest/Google Logo.png'
import signupshapeimg from '../../assest/log in, sign up & answer page png.png'
import { Link } from "react-router-dom";

const SignUpForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    cellNumber: "",
    password: "",
    userType: "teacher",
    termsAccepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.termsAccepted) {
      alert("Please accept the terms and conditions.");
      return;
    }
    console.log("Form Data Submitted:", formData);
    
  };

  return (
    <>
     <div className='signup-container'>
        <div className='signup-left'>
            <img src={signupimg}/>
            <div className="overlay-img">
                <img src={rocketimg}/>
            </div>
        </div>
   
    <section className="signup-right">
      <h2>ExamSify Sign Up</h2>
      <div className="signup-shape">
        <img src={signupshapeimg}/>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div>
            <label htmlFor="firstName">Your Name</label>
            <input
              className="input-text"
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First name"
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor="lastName" style={{ visibility: "hidden" }}>
              .
            </label>
            <input
             className="input-text"
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last name"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>
        </div>
        <div>
          <label className="email-label" htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="cellNumber">Cell Number</label>
          <input
            type="tel"
            id="cellNumber"
            name="cellNumber"
            placeholder="Enter number"
            value={formData.cellNumber}
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>

        <fieldset>
          <legend>Are You ?</legend>
          <label>
            <input
              type="radio"
              name="userType"
              value="parent"
              checked={formData.userType === "parent"}
              onChange={handleChange}
            />{" "}
            A Parent
          </label>
          <label>
            <input
              type="radio"
              name="userType"
              value="student"
              checked={formData.userType === "student"}
              onChange={handleChange}
            />{" "}
            A Student
          </label>
          <label>
            <input
              type="radio"
              name="userType"
              value="teacher"
              checked={formData.userType === "teacher"}
              onChange={handleChange}
            />{" "}
            A Teacher
          </label>
        </fieldset>

        <div className="checkbox-row">
          <input
            type="checkbox"
            id="terms"
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={handleChange}
          />
          <label htmlFor="terms">
            I Agree with all of your{" "}
            <Link style={{ color: "#2563eb", textDecoration: "underline" }}>
              Terms & Conditions
            </Link>
          </label>

        <div className="submit-row">
          <button className="submit-btn" type="submit" onClick={handleSubmit}>
            <span>Create Account</span>
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
        </div>

        <div className="divider">
          <hr />
          <span>SIGN UP WITH</span>
          <hr />
        </div>

        <button type="button" className="google-btn">
          <img
            src={googlelogoimg}
            alt="Google logo"
            width="20"
            height="20"
          />
          <span>Google</span>
        </button>

      <Link to={"/login"}> <p className="already">Already Registered to ExamSify</p></Link> 
      </form>
    </section>
       </div>
    </>
  );
};

export default SignUpForm;
